<template class="pt-0">
    <v-container fluid class="pt-0">
        <v-sheet height="5%" class="pt-0 pb-3">
            <v-row no-gutters>
                <v-col cols="12" md="8" align-self="center">
                    <div v-if="tecnicosSelec.length > 0">
                        Mostrando horario de:
                        <span v-for="(item, index) in tecnicosSelec" :key="index">
                            <v-chip
                                :color= "item.color"
                                class="mr-2"
                                outlined
                                small
                                close 
                                @click:close="removeFiltro(item)"
                            >
                                {{ item.nombre }}
                            </v-chip>
                        </span>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <v-toolbar flat>
                        <v-spacer></v-spacer>
                        <v-btn fab small text color="grey darken-2" @click="$refs.calendar.prev(), accionesSemana()">
                            <v-icon small>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-toolbar-title v-if="$refs.calendar">
                            {{ $refs.calendar.title }}
                        </v-toolbar-title>
                        <v-btn fab small text color="grey darken-2" @click="$refs.calendar.next(), accionesSemana()">
                            <v-icon small>mdi-chevron-right</v-icon>
                        </v-btn>
                        <v-spacer v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"></v-spacer>
                    </v-toolbar>
                </v-col>
            </v-row>
        </v-sheet>
        <v-sheet height="95%">
            <v-calendar
                ref="calendar"
                :events="events"
                color="primary"
                type="week"
                :weekdays="ordenDias"
                :weekday-format="cambioNombreDias"
                :interval-format="formatoHora"
                :event-color="colorEvento"
                v-model="fecha"
                style="height: 80vh;"
                @click:event="mostrarEvento"
            >
                <template v-slot:day-body="{ date, week }">
                    <div
                        class="v-current-time"
                        :class="{ first: date === week[0].date }"
                        :style="{ top: nowY }"
                    ></div>
                </template>
            </v-calendar>
            <v-menu v-model="mostrarDatosEvento" :close-on-content-click="false" :activator="elementoSelec" offset-x>
                <v-card color="grey lighten-4" max-width="400" flat>
                    <v-toolbar :color="eventoSelec.color" dark>
                        <v-toolbar-title>{{ eventoSelec.name }} </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon link :href="`${envURL}/partes/${eventoSelec.parteId}`">
                            <v-icon>mdi-launch</v-icon>
                        </v-btn>
                        <v-btn icon @click="mostrarDatosEvento = false">
                            <v-icon>mdi-window-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <p class="mb-0" style="color: black"><span class="font-weight-bold">Tecnico: </span>{{ eventoSelec.tecnico }}</p>
                        <p class="mb-0" style="color: black"><span class="font-weight-bold">Hora: </span>{{ eventoSelec.rangoHoras }}</p>
                        <p class="mb-0" style="color: black"><span class="font-weight-bold">Contrato: </span>{{ eventoSelec.contrato }}</p>
                        <p class="mb-0" style="color: black"><span class="font-weight-bold">Ambito: </span>{{ eventoSelec.ambito }}</p>
                        <p class="mb-0" style="color: black"><span class="font-weight-bold">Urgencia: </span>{{ eventoSelec.urgencia }}</p>
                        <p class="mb-0" style="color: black"><span class="font-weight-bold">Observaciones de la acción: </span>{{ eventoSelec.details }}</p>
                        <v-icon v-if="eventoSelec.desplazamiento">mdi-car</v-icon>
                    </v-card-text>
                </v-card>
            </v-menu>
        </v-sheet>
        
        <v-btn color="teal lighten-1" fab dark @click="dialogFiltrar = true, fechaDialog = fecha, fechaFormateadaDialog = fechaFormateada" fixed style="bottom: 37px; right: 30px;">
            <v-icon>mdi-filter-outline</v-icon>
        </v-btn>

        <v-dialog v-model="dialogFiltrar" persistent max-width="750">
            <v-card>
                <v-card-title class="headline"><p>Filtros</p></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6" class="pt-0">
                            <v-dialog ref="dialogFecha" v-model="modalFecha" :return-value.sync="fechaDialog" persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field 
                                        v-model="fechaFormateadaDialog" 
                                        prepend-icon="mdi-calendar" 
                                        label="Fecha" v-bind="attrs" 
                                        v-on="on" 
                                        @blur="fechaDialog = parseDate(fechaFormateadaDialog)" 
                                        readonly
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="fechaDialog" scrollable :first-day-of-week="1">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="modalFecha = false">Cancelar</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialogFecha.save(fechaDialog)">Aceptar</v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="6" class="pt-0">
                            <v-autocomplete
                                v-model="tecnicosSelecDialog"
                                :items="tecnicos"
                                small-chips
                                label="Técnico asignado"
                                item-text="nombreCompleto"
                                item-value="id"
                                multiple
                                return-object
                                @input="searchInput=null"
                                :search-input.sync="searchInput">
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                        v-bind="data.attrs"
                                        :input-value="data.selected"
                                        close
                                        small
                                        @click:close="removeTecnico(data.item)"
                                    >
                                        <v-avatar left :color="data.item.color">
                                        <span class="white--text">{{
                                            data.item.avatar
                                        }}</span>
                                        </v-avatar>
                                        {{ data.item.nombre }}
                                    </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                    <template>
                                        <v-list-item-avatar :color="data.item.color">
                                        <span class="white--text">{{
                                            data.item.avatar
                                        }}</span>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                        <v-list-item-title>{{
                                            data.item.nombre
                                        }}</v-list-item-title>
                                        <v-list-item-subtitle>{{
                                            data.item.apellidos
                                        }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelarFiltrado()">Cancelar</v-btn>
                    <v-btn color="primary" text @click="aplicarFiltros()" :disabled="this.$v.tecnicosSelecDialog.$invalid">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import formatDate from "@/mixins/formatearFecha";
import parseDate from "@/mixins/formatearFecha";
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    name: 'Calendario',
    mixins: [formatDate, parseDate],
    data: () => ({
        start: null,
        events: [],
        ordenDias: [1, 2, 3, 4, 5, 6, 0],

        dialogFecha: false,
        fechaFormateadaDialog: null,
        fechaDialog: '',
        modalFecha: false,
        fechaFormateada: null,
        fecha: '',

        ready: false,

        mostrarDatosEvento: false,
        elementoSelec: null,
        eventoSelec: {},

        dialogFiltrar: false,
        // tecnicos: [],
        tecnicosSelecDialog: [],
        tecnicosSelec: [],

        searchInput: null,
    }),
    async created(){
        var formatoFecha = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        };
        let hoy = new Date().toLocaleString("es", formatoFecha);
        this.fecha = this.parseDate(hoy);

        // let respuesta = await axios.get("/api/usuarios?grupo=2"); //LISTAR TECNICOS BDD 
        // this.tecnicos = respuesta.data.map(t => { return  {...t,  nombreCompleto: t.name + ' ' + t.apellidos }; }); //Le añadimos a todos los tecnicos el campo nombreCompleto

        if (!this.tecnicos.length) {
            this.$store.dispatch("usuarios/getUsuarios");
        }
        
        let usuarioAutenticado = {...this.authUser, nombre: this.authUser.name}
        this.tecnicosSelec.push(usuarioAutenticado);
        this.tecnicosSelecDialog = JSON.parse(JSON.stringify(this.tecnicosSelec));

        this.accionesSemana();
    },
    mounted(){
        this.ready = true;
        this.scrollToTime();
        setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },
    methods: {
        ...mapActions(['setSnackbar', 'setLoading']),
		cambioNombreDias(dia) {
            switch (dia.weekday) {
                case 1:
                    return 'Lunes'
                case 2:
                    return 'Martes'
                case 3:
                    return 'Miercoles'
                case 4:
                    return 'Jueves'
                case 5:
                    return 'Viernes'
                case 6:
                    return 'Sabado'
                case 0:
                    return 'Domingo'
            }
		},
        scrollToTime () {
            const time = this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0;
            const first = Math.max(0, time - (time % 30) - 30);

            this.cal.scrollToTime(first);
        },
        formatoHora(locale) {
            return locale.time;
        },
        colorEvento (event) {
            return event.color;
        },
        mostrarEvento ({ nativeEvent, event }) {
            const open = () => {
                console.log(event);
                this.eventoSelec = event;
                this.elementoSelec = nativeEvent.target;
                requestAnimationFrame(() => requestAnimationFrame(() => this.mostrarDatosEvento = true));
            }

            if (this.mostrarDatosEvento) {
                this.mostrarDatosEvento = false;
                requestAnimationFrame(() => requestAnimationFrame(() => open()));
            } else {
                open();
            }

            nativeEvent.stopPropagation();
        },
        aplicarFiltros(){
            this.fecha = this.fechaDialog;
            this.tecnicosSelec = JSON.parse(JSON.stringify(this.tecnicosSelecDialog));
            this.accionesSemana();
        },
        cancelarFiltrado(){
            this.dialogFiltrar = false
            this.tecnicosSelecDialog = JSON.parse(JSON.stringify(this.tecnicosSelec));
            this.fechaDialog = this.fecha;
        },
        async accionesSemana(){ //OBTENEMOS LOS DIA DE LA SEMANA SELECCIONADA DE LUNES A VIERNES
            this.setLoading(true);
            let dias = 0    
            let f = new Date(this.fecha);
            //calcula los dias que se tienen que restar para estar en lunes
            if(f.getUTCDay()==0){ //si es domingo
                dias=(-6);        
            }else{ //el resto de dias
                dias=(f.getUTCDay()-1)*(-1);   
            }

            f.setDate(f.getDate() + dias);
            let lunes = this.formatDate(f.toISOString().substr(0, 10));
            
            f.setDate(f.getDate() + 6);
            let domingo = this.formatDate(f.toISOString().substr(0, 10));

            let IDtecnicosSelec = []
            this.tecnicosSelec.forEach(tecnico => {
                IDtecnicosSelec.push(tecnico.id);
            });
            if(IDtecnicosSelec.length == 0){
                this.setLoading(false);
            }else {
                try {
                    let params = {
                        lunes: this.parseDate(lunes),
                        ultimoDia: this.parseDate(domingo),
                        tecnicos: IDtecnicosSelec
                    }
                    let respuesta = await axios.get('/api/acciones', { params }); //Recuperar las acciones de los usuarios indicados relizadas la semana que se muestra
                    console.log(respuesta);
                    let accionesSemana = respuesta.data;
                    this.events = [];
                    console.log(accionesSemana);
                    accionesSemana.forEach(accion => {
                        let evento = {
                            name: accion.parte.cliente,
                            start: accion.fecha +" "+ accion.entrada,
                            end: accion.fecha +" "+ accion.salida,
                            details: accion.comentarios,
                            color: accion.user.color,
                            tecnico: accion.user.name + ' ' + accion.user.apellidos,
                            rangoHoras: accion.entrada.substring(0,5) + ' - '+ accion.salida.substring(0,5),
                            parteId: accion.parte_id,
                            contrato: accion.contrato.contrato,
                            ambito: accion.ambito.ambito,
                            urgencia: accion.urgencia.urgencia,
                            desplazamiento: accion.desplazamiento
                        }
                        this.events.push(evento);//condicion de que no exista en el array
                    });
                    
                    this.setLoading(false);
                    this.dialogFiltrar = false;
                } catch (error) {
                    console.log(error);
                    this.setLoading(false);
                    this.dialogFiltrar = false;
                    this.setSnackbar({
                        tipo: "error",
                        mensaje: "Error. No se han podido recuperar las acciones",
                    });
                }
            }
        },
        removeTecnico(item){
            let posicion = -1;
            this.tecnicosSelecDialog.filter(function (tecnico, i) {
                if (tecnico.id === item.id) {
                    posicion = i;
                }
            });
            if (posicion >= 0) this.tecnicosSelecDialog.splice(posicion, 1);
        },
        removeFiltro(item){
            this.removeTecnico(item);

            let posicion = -1;
            this.tecnicosSelec.filter(function (tecnico, i) {
                if (tecnico.id === item.id) {
                    posicion = i;
                }
            });
            if (posicion >= 0) this.tecnicosSelec.splice(posicion, 1);

            if(this.tecnicosSelec.length >= 1){
                this.accionesSemana();
            }else{
                this.events = [];
            }
        }
    },
    computed: {
        ...mapState('login', ['authUser']),
        ...mapGetters({tecnicos: "usuarios/tecnicos"}),
        cal () {
            return this.ready ? this.$refs.calendar : null
        },
        nowY () {
            return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
        },
        // Temporal mientras migramos el calendario a v3.
        envURL(){
            return process.env.VUE_APP_V3_URL
        }
    },
    watch: {
        fecha() {
            this.fechaFormateada = this.formatDate(this.fecha);
        },
        fechaDialog() {
            this.fechaFormateadaDialog = this.formatDate(this.fechaDialog);
        }
    },
    validations: {
      tecnicosSelecDialog: { required }
    },
}
</script>
<style>
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;
}
</style>